function minutesFromTime(value: string) {
  const [hour, minute] = value.slice(0, 5).split(":").map(Number);
  return hour * 60 + minute;
}

export function durationMinutes(startTime: string, endTime: string, fallback = 60) {
  if (!startTime || !endTime) return fallback;
  return Math.max(15, minutesFromTime(endTime) - minutesFromTime(startTime));
}

export function durationLabel(value: number) {
  const hourPart = Math.floor(value / 60);
  const minutePart = value % 60;
  if (!hourPart) return `${minutePart} min`;
  if (!minutePart) return `${hourPart} hr${hourPart === 1 ? "" : "s"}`;
  return `${hourPart} hr ${minutePart} min`;
}
